import ValidateClabe from './ValidateClabe';

export * from "./hooks/useValidateClabe"

export default ValidateClabe;